import { theme } from '@huspy/forge';

export const minMd = `screen and (min-width: ${theme.breakpoints.md})`;
export const minXl = `screen and (min-width: ${theme.breakpoints.xl})`;
export const minXxl = `screen and (min-width: ${theme.breakpoints.xxl})`;
export const maxMd = `screen and (max-width: ${theme.breakpoints.md})`;
export const imagesPath = '/images';
export const iconsPath = '/icons';
